* {
    box-sizing: border-box;
}

:host {
    display: flex;
    flex-direction: column;
    border: 2px solid var(--color-shade-10);
    border-radius: 20px;
    padding: 12px 30px;
}

section {
    border-bottom: 4px solid var(--color-shade-10);
    overflow: hidden;
}

section.collapsed .section_header es-icon {
        transform: rotate(-180deg);
    }

section:last-of-type {
        border-bottom: 0;
    }

section.mega {
        border-bottom: none;
    }

section.mega .section_content_inner {
            padding: 0;
        }

section.footer .section_content_inner {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            justify-content: flex-end;
            padding-top: 30px;
            padding-bottom: 20px;
        }

section.field .section_content_inner {
            padding-bottom: 20px;
        }

section.field .section_header + .section_content > .section_content_inner {
            padding-top: 0;
        }

section.text .section_content_inner {
            padding-top: 0;
            padding-bottom: 10px;
        }

section.text .section_header + .section_content > .section_content_inner {
            padding-top: 0;
        }

.section_header {
    min-height: 55px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 14px 0px;
}

.section_header.collapsable {
        cursor: pointer;
    }

.section_header h1 {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        margin: 0;
        color: var(--color-text);
    }

.section_header h1 .step {
            color: var(--color-secondary);
            margin-right: 14px;
        }

.section_header es-icon {
        transform: rotate(0deg);
        transition: transform 500ms ease;
        margin-left: auto;
        margin-right: 16px;
    }

.section_content {
    box-sizing: border-box;
    overflow: hidden;

    transition-duration: 500ms;
    transition-timing-function: ease;
}

.section_content[aria-hidden='true'] {
        opacity: 0;
        height: 0;
    }

.section_content_inner {
    overflow: hidden;
    padding: 40px 0;
}

.section_header + .section_content > .section_content_inner {
    padding-top: 30px;
}

::slotted(es-button[slot='footer']),
::slotted(es-button-link[slot='footer']) {
    width: auto;
    margin-left: 10px;
}

::slotted(es-mega-input) {
    margin-bottom: 0;
}
